export class FPSCounter {
  private times: number[];
  private element: HTMLElement | null;
  private frameCount: number;
  private lastUpdate: number;
  private updateInterval: number;

  constructor() {
    this.times = [];
    this.element = document.getElementById('fps-counter');
    this.frameCount = 0;
    this.lastUpdate = performance.now();
    this.updateInterval = 500; // Update every 500ms
  }

  public update(): void {
    const now = performance.now();
    
    // Calculate FPS using a moving window
    while (this.times.length > 0 && this.times[0] <= now - 1000) {
      this.times.shift();
    }
    this.times.push(now);
    const fps = this.times.length;

    // Update display every 500ms to avoid too frequent DOM updates
    if (now - this.lastUpdate > this.updateInterval) {
      if (this.element) {
        this.element.textContent = `FPS: ${fps}`;
      }
      this.lastUpdate = now;
    }
  }
} 